var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typing"},[_c('no-ssr',[(_vm.ready)?_c('en',{attrs:{"s":_vm.typingCurrent()}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"m-typing-cursor"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }